{
  "SectionHint": "U kunt de ACD Niet-Beschikbare redencode afzonderlijk specificeren die wordt gebruikt voor het berekenen van elk van de 10 verschillende statistische varianten van de totale en gemiddelde Niet-Beschikbare ACD-statustijd. Selecteer de 10 onderstaande codes waarvoor ACD-statustijdstatistieken afzonderlijk worden gemeten:",
  "NaCode01Label": "Niet-beschikbare code 01:",
  "NaCode02Label": "Niet-beschikbare code 02:",
  "NaCode03Label": "Niet-beschikbare code 03:",
  "NaCode04Label": "Niet-beschikbare code 04:",
  "NaCode05Label": "Niet-beschikbare code 05:",
  "NaCode06Label": "Niet-beschikbare code 06:",
  "NaCode07Label": "Niet-beschikbare code 07:",
  "NaCode08Label": "Niet-beschikbare code 08:",
  "NaCode09Label": "Niet-beschikbare code 09:",
  "NaCode10Label": "Niet-beschikbare code 10:",
  "UseCodeDescriptionLabel": "Gebruik codebeschrijving in ACD NA-codegerelateerde statistieken",
  "ResetCodesHeader": "Reset codes",
  "ResetCodesHint": "Als er momenteel niet-beschikbare ACD-redencodes zijn geconfigureerd in uw telefonieomgeving en de eerste 10 hiervan verschillen van de huidige instellingswaarden die hierboven worden weergegeven, kunt u op de volgende knop klikken om de instellingswaarden standaard in te stellen met behulp van de eerste tien gedetecteerde codes.",
  "ResetCodesButtonText": "Reset codes",
  "ResetCodesConfirmDialogHint": "Weet u zeker dat u alle statistische instellingen van ACD Niet-beschikbare redencodes wilt resetten naar de eerste 10 codes die momenteel zijn geconfigureerd in uw telefonieomgeving?",
  "ACDCodesLanguage_SectionHeader": "Varianten van ACD niet-beschikbare tijdstatistieken",
  "NAME": "ACDCodesLanguage",
  "NaCode11Label": "Niet-beschikbare code 11:"
}